import { Box, Popover, type FloatingPosition, rem } from '@mantine/core';
import { THEME_COLORS } from '@vrplatform/ui-common';
import { isValidElement, type ComponentProps, type ReactElement } from 'react';
import { VRPilotCoachmark } from './VRPilotCoachmark';
import { VRPilotHighlight } from './VRPilotHighlight';

export const VRPilotCoachmarkTarget = ({
  children,
  coachmark,
  opened,
  placement = 'right-start',
}: {
  children: ReactElement;
  coachmark: Omit<ComponentProps<typeof VRPilotCoachmark>, 'placement'>;
  opened: boolean;
  placement?: FloatingPosition;
}) => {
  if (!isValidElement(children)) return null;

  return (
    <Popover
      // Popover's own arrow follows the target when shift moves the coachmark.
      arrowPosition="center"
      arrowSize={10}
      closeOnClickOutside={false}
      middlewares={{ flip: true, shift: true }}
      offset={14}
      opened={opened}
      position={placement}
      shadow="none"
      styles={{
        arrow: {
          background: THEME_COLORS.neutral[0],
          borderColor: THEME_COLORS.violet[6],
          borderWidth: rem(1),
        },
      }}
      trapFocus={false}
      withArrow
      withinPortal
    >
      <Popover.Target>
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <VRPilotHighlight>{children}</VRPilotHighlight>
        </Box>
      </Popover.Target>
      <Popover.Dropdown
        p={0}
        sx={{
          background: 'transparent',
          border: 0,
          boxShadow: 'none',
          minWidth: 0,
        }}
      >
        <VRPilotCoachmark {...coachmark} />
      </Popover.Dropdown>
    </Popover>
  );
};
